import BookingConfirmation from '../../../components/sections/osb-v3/booking-confirmation/booking-confirmation';

export function OsbV3BookingConfirmationView() {
    return (
        <div className="osb-v3-confirmation-view-container">
            <BookingConfirmation />
        </div>
    );
}
